<template>
  <div id="content">
  </div>
</template>

<script>
import api from '../services/api'
import { mapState } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    isAuth () {
      return this.$store.state.isAuth
    }
  },
  async created() {
    if (this.isAuth) {
      this.$router.push({ name: 'dashboard' })
    } else {
      this.$router.push({ name: 'login' })
    }
    // this.$router.push({ name: 'login' })
  },
  methods : {
  }
}
</script>




